import * as React from 'react';

const ProductBlockInner = ({ children  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "v2-product-block-inner"
    }, children);
};

export { ProductBlockInner };
//# sourceMappingURL=ProductBlockInner.js.map
